/**
 * Event names of the component.
 */
export enum TimelineEvents {
  Selected = 'selected',
  TimeChanged = 'timechanged',
  KeyframeChanged = 'keyframeChanged',
  DragStarted = 'dragStarted',
  Drag = 'drag',
  DragFinished = 'dragFinished',
  Scroll = 'scroll',
  ScrollFinished = 'scrollFinished',
  ContextMenu = 'onContextMenu',
  DoubleClick = 'doubleClick',
  MouseDown = 'mouseDown',
}
